<div class="td-wb-modal-notification">
  <h1 class="td-wb-modal-notification__header"
      translate="tdWb.modalNotification.recurringInvestments.TITLE"></h1>
  <div class="td-wb-modal-notification__row">
    <div class="td-wb-modal-notification__left">
      <p class="td-wb-modal-notification__copy--bold"
         translate="tdWb.modalNotification.recurringInvestments.SUBHEADER"></p>
      <div class="td-wb-modal-notification__copy">
        <div class="td-wb-modal-notification__margin-bottom"
             translate="tdWb.modalNotification.recurringInvestments.DESCRIPTION_I"></div>
        <ul class="td-wb-ul td-wb-ul--basic td-wb-modal-notificiation__list-body">
          <li translate="tdWb.modalNotification.recurringInvestments.DETAILS_I"></li>
          <li translate="tdWb.modalNotification.recurringInvestments.DETAILS_II"></li>
          <li translate="tdWb.modalNotification.recurringInvestments.DETAILS_III"></li>
        </ul>
        <div class="td-wb-modal-notification__text-and-link-container">
          <span translate="tdWb.modalNotification.recurringInvestments.DESCRIPTION_II"></span>
          <a class="td-wb-modal-notification__link td-wb-modal-notification__link--no-margin"
             tdWbHref="link_buy_sell_Equities"
             translate="tdWb.modalNotification.recurringInvestments.SEE_HOW"></a>
        </div>
      </div>
    </div>
    <div class="td-wb-modal-notification--image-container">
      <img tdWbModalNotificationImage
           width="400px"
           height="180px"
           src="recurring-investments.svg"
           [attr.alt]="'tdWb.modalNotification.recurringInvestments.TITLE' | translate" />
    </div>
  </div>
</div>
